import { render } from "./MyLoading.vue?vue&type=template&id=8ab27e56"
import script from "./MyLoading.vue?vue&type=script&lang=js"
export * from "./MyLoading.vue?vue&type=script&lang=js"

import "./MyLoading.vue?vue&type=style&index=0&id=8ab27e56&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__